// App.js — dartfun landing page
import { useEffect, useState } from 'react';

function App() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setTimeout(() => setLoaded(true), 100);
  }, []);

  const appStoreUrl = 'https://apps.apple.com/app/dartsbooth/id6772752853';
  const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.codebooth.dartfun';

  return (
    <div style={{
      background: '#1a1a1a',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      overflow: 'hidden',
      fontFamily: "'Comfortaa', sans-serif",
    }}>
      {/* background glow effects */}
      <div style={{
        position: 'absolute', top: '-20%', left: '-10%',
        width: '500px', height: '500px', borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(230,57,70,0.08) 0%, transparent 70%)',
        filter: 'blur(60px)', pointerEvents: 'none',
      }} />
      <div style={{
        position: 'absolute', bottom: '-20%', right: '-10%',
        width: '600px', height: '600px', borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(241,196,15,0.06) 0%, transparent 70%)',
        filter: 'blur(80px)', pointerEvents: 'none',
      }} />
      <div style={{
        position: 'absolute', top: '40%', right: '20%',
        width: '300px', height: '300px', borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(46,204,113,0.05) 0%, transparent 70%)',
        filter: 'blur(50px)', pointerEvents: 'none',
      }} />

      {/* content */}
      <div style={{
        position: 'relative', zIndex: 1,
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        padding: '40px 24px', maxWidth: '480px', textAlign: 'center',
        opacity: loaded ? 1 : 0,
        transform: loaded ? 'translateY(0)' : 'translateY(30px)',
        transition: 'all 0.8s cubic-bezier(0.16, 1, 0.3, 1)',
      }}>
        {/* logo */}
        <img
          src="/logo.png"
          alt="DartsBooth"
          style={{
            width: '160px', height: 'auto', marginBottom: '32px',
            opacity: loaded ? 1 : 0,
            transform: loaded ? 'scale(1)' : 'scale(0.8)',
            transition: 'all 1s cubic-bezier(0.34, 1.56, 0.64, 1) 0.2s',
          }}
        />

        {/* tagline */}
        <h1 style={{
          fontSize: '28px', fontWeight: '700', color: '#f5f5f5',
          margin: '0 0 12px', lineHeight: '1.3', letterSpacing: '-0.5px',
          opacity: loaded ? 1 : 0,
          transform: loaded ? 'translateY(0)' : 'translateY(15px)',
          transition: 'all 0.7s ease 0.3s',
        }}>
          Score darts.<br />Not on paper.
        </h1>

        <p style={{
          fontSize: '15px', color: '#888', lineHeight: '1.6',
          margin: '0 0 40px', maxWidth: '340px',
          opacity: loaded ? 1 : 0,
          transform: loaded ? 'translateY(0)' : 'translateY(15px)',
          transition: 'all 0.7s ease 0.4s',
        }}>
          501, 301, Killer, Cricket, and Teams.<br />
          Just open and throw.
        </p>

        {/* game mode pills */}
        <div style={{
          display: 'flex', flexWrap: 'wrap', gap: '8px',
          justifyContent: 'center', marginBottom: '48px',
          opacity: loaded ? 1 : 0,
          transform: loaded ? 'translateY(0)' : 'translateY(15px)',
          transition: 'all 0.7s ease 0.5s',
        }}>
          {[
            { label: '501', color: '#e63946' },
            { label: '301', color: '#3498db' },
            { label: 'Killer', color: '#9b59b6' },
            { label: 'Cricket', color: '#2ecc71' },
            { label: 'Teams', color: '#f1c40f' },
          ].map((mode) => (
            <span key={mode.label} style={{
              padding: '6px 16px', borderRadius: '999px',
              fontSize: '12px', fontWeight: '700', letterSpacing: '0.5px',
              color: mode.color,
              background: `${mode.color}15`,
              border: `1px solid ${mode.color}30`,
            }}>{mode.label}</span>
          ))}
        </div>

        {/* store buttons */}
        <div style={{
          display: 'flex', flexDirection: 'column', gap: '12px', alignItems: 'center',
          opacity: loaded ? 1 : 0,
          transform: loaded ? 'translateY(0) scale(1)' : 'translateY(15px) scale(0.95)',
          transition: 'all 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) 0.6s',
        }}>
          <a
            href={appStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-flex', alignItems: 'center', gap: '12px',
              padding: '14px 28px', borderRadius: '14px', width: '280px', justifyContent: 'center',
              background: '#fff', color: '#1a1a1a', textDecoration: 'none',
              fontSize: '15px', fontWeight: '700',
              boxShadow: '0 4px 24px rgba(255,255,255,0.1)',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            }}
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
            </svg>
            App Store
          </a>
          <a
            href={playStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-flex', alignItems: 'center', gap: '12px',
              padding: '14px 28px', borderRadius: '14px', width: '280px', justifyContent: 'center',
              background: 'transparent', color: '#fff', textDecoration: 'none',
              fontSize: '15px', fontWeight: '700',
              border: '1px solid rgba(255,255,255,0.2)',
              transition: 'transform 0.2s ease, border-color 0.2s ease',
            }}
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.199l2.302 2.302a1 1 0 0 1 0 1.38l-1.98 1.147-2.56-2.56 2.238-2.269zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z"/>
            </svg>
            Google Play
          </a>
        </div>

        {/* features row */}
        <div style={{
          display: 'flex', gap: '24px', marginTop: '56px',
          opacity: loaded ? 1 : 0,
          transition: 'all 0.7s ease 0.8s',
        }}>
          {[
            { icon: '\uD83C\uDFAF', text: 'Checkout hints' },
            { icon: '\uD83D\uDCCA', text: 'Match history' },
            { icon: '\uD83C\uDF19', text: 'Dark mode' },
          ].map((f) => (
            <div key={f.text} style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px',
            }}>
              <span style={{ fontSize: '24px' }}>{f.icon}</span>
              <span style={{ fontSize: '11px', color: '#666', fontWeight: '600' }}>{f.text}</span>
            </div>
          ))}
        </div>
      </div>

      {/* footer */}
      <div style={{
        position: 'absolute', bottom: '24px',
        display: 'flex', gap: '20px', alignItems: 'center',
        opacity: loaded ? 0.4 : 0,
        transition: 'all 0.7s ease 1s',
      }}>
        <a href="/privacy.html" style={{
          color: '#888', fontSize: '11px', textDecoration: 'none',
          fontFamily: "'Comfortaa', sans-serif",
        }}>Privacy</a>
        <span style={{ color: '#444', fontSize: '11px' }}>|</span>
        <span style={{ color: '#888', fontSize: '11px', fontFamily: "'Comfortaa', sans-serif" }}>
          CodeBooth 2026
        </span>
      </div>
    </div>
  );
}

export default App;